import React from 'react';
import { hostInfo, siteConfig } from '../data/mock';
import { useTheme } from '../context/ThemeContext';

const AboutSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="about" className={`relative py-24 ${isDark ? 'bg-stone-900' : 'bg-white'}`}>
      {/* Subtle background pattern */}
      <div className={`absolute inset-0 ${isDark ? 'opacity-5' : 'opacity-[0.03]'}`}>
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Grid */}
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              {hostInfo.images.map((image, index) => (
                <div
                  key={index}
                  className={`relative overflow-hidden rounded-2xl ${
                    index === 0 ? 'col-span-2' : ''
                  }`}
                >
                  <img
                    src={image}
                    alt={`${hostInfo.name} lifestyle ${index + 1}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    style={{ aspectRatio: index === 0 ? '16/9' : '1/1' }}
                  />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-950/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
                </div>
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-8">
            {/* Section label */}
            <div className="inline-flex items-center gap-3">
              <div className="h-px w-12 bg-amber-500" />
              <span className="text-amber-500 font-medium uppercase tracking-wider text-sm">About the Host</span>
            </div>

            {/* Heading */}
            <h2 className={`text-4xl sm:text-5xl font-bold ${isDark ? 'text-stone-100' : 'text-stone-800'}`}>
              Meet {hostInfo.name}
            </h2>

            {/* Bio paragraphs */}
            <div className="space-y-4">
              {hostInfo.bio.map((paragraph, index) => (
                <p key={index} className={`leading-relaxed ${isDark ? 'text-stone-400' : 'text-stone-600'}`}>
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Mission statement */}
            <div className={`border-l-4 border-amber-500 p-6 rounded-r-xl ${isDark ? 'bg-stone-800/50' : 'bg-amber-50'}`}>
              <p className={`italic ${isDark ? 'text-stone-300' : 'text-stone-700'}`}>
                "{siteConfig.mission}"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
